import * as React from 'react';

import user from 'js/lib/user';

import EnterpriseBanner from 'bundles/program-home/components/enterprise-home/EnterpriseBanner';
import { useEnterpriseProductFeatures } from 'bundles/unified-common/contexts/EnterpriseProductFeaturesContext';
import {
  useIsC4cv,
  useIsUpswell,
  useProgram,
  useProgramMembership,
} from 'bundles/unified-common/contexts/EnterpriseProgramContext';
import { useThirdPartyOrganization } from 'bundles/unified-common/contexts/ThirdPartyOrganizationContext';

/*
If any changes need to be made to this component, a new component is required that follows the principles of a unified component:
https://docs.google.com/document/d/1UYVcedo1viLDNyNOCZ2J3gNbM_XIVqQyOZ3VykzXQU8/edit

When we need to make use of some common functionality and/or don't have the scope to re-build a component in our unified patterns,
we import the component in a wrapper like so that clearly defines this component does not meet the standards of a unified module.

It is advised we don't do this too often, components in a 'Not Configurable' wrapper should not be iterated on and left as is.
*/

const EnterpriseHeroNotConfigurable = () => {
  const thirdPartyOrg = useThirdPartyOrganization();
  const program = useProgram();
  const programMembership = useProgramMembership();
  const features = useEnterpriseProductFeatures();
  const isUpswell = useIsUpswell();
  const isC4cv = useIsC4cv();
  const shouldShowJoinButton: unknown =
    !features?.isBrowseOnlyProgram &&
    (!user.isAuthenticatedUser() ||
      programMembership?.membership?.membershipState === 'INVITED' ||
      programMembership?.membership?.membershipState === 'WHITELISTED');

  if (!thirdPartyOrg) {
    return null;
  }

  return (
    <EnterpriseBanner
      thirdPartyOrganization={thirdPartyOrg}
      program={program}
      isMultiProgram={false}
      isProgramDetailsView={true}
      shouldShowJoinButton={!!shouldShowJoinButton}
      isUpswell={!!isUpswell}
      isC4cv={!!isC4cv}
    />
  );
};

export default EnterpriseHeroNotConfigurable;
